import { RemoteProviderPromotionType } from "../../../../data/usecases/promotion-type/remote-provider-promotion-type";
import { PromotionType } from "../../../../domain/models/promotion-type";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteProviderPromotionType = (): PromotionType =>
  new RemoteProviderPromotionType(
    "/providerPromotionType",
    makeAxiosHttpClient()
  );
